export enum MutationTypes {
  SET_EXTERNAL_ACCESSES = "external-access-module/set-external-accesses",
  SET_EXTERNAL_ACCESS = "external-access-module/set-external-access",
  SET_EXTERNAL_ACCESSES_META = "external-access-module/set-external-accesses-meta",
}
